import type { PatternProps } from "./shared";

export function CheckerPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-checkerPattern`}
				patternUnits="userSpaceOnUse"
				width="35"
				height="35"
			>
				<rect
					x="0"
					y="0"
					width="17.5"
					height="17.5"
					fill={color}
				/>
				<rect
					x="17.5"
					y="17.5"
					width="17.5"
					height="17.5"
					fill={color}
				/>
			</pattern>
		</defs>
	);
}
